module.exports = __webpack_public_path__ + "img/small_flt_washer.prt.6ef03e24.jpg";